import { useState, type FormEvent } from "react";
import { authApi } from "../../api/auth";
import { Button, ErrorText, Field, TextInput } from "../../components/ui";
import type { AdminStep } from "./AdminLogin";

export function PasswordChangeStep({ onNext, onError }: { onNext: (s: AdminStep) => void; onError: (e: unknown) => string }) {
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (pw !== pw2) return setError("The two new passwords don't match.");
    setBusy(true); setError(null);
    try {
      const r = await authApi.changeTempPassword(current, pw);
      onNext(r.next_step === "MFA_VERIFY" ? "totp" : "enroll");
    } catch (err) { setError(onError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-5" data-testid="admin-password-change-form">
      <Field label="Temporary password" htmlFor="pc-current"><TextInput id="pc-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" data-testid="pc-current-input" /></Field>
      <Field label="New password (12+ characters)" htmlFor="pc-new"><TextInput id="pc-new" type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" data-testid="pc-new-input" /></Field>
      <Field label="Repeat new password" htmlFor="pc-new2"><TextInput id="pc-new2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" data-testid="pc-new2-input" /></Field>
      <ErrorText message={error} testId="pc-error" />
      <Button type="submit" loading={busy} disabled={!current || pw.length < 12} className="w-full" data-testid="pc-submit-btn">Set password &amp; continue to 2FA</Button>
    </form>
  );
}
